import encodeChars from './encodeChars';
import decodeChars from './decodeChars';

export default {
  encode(data, filter) {
    const {name} = filter;
    const key = encodeChars.colon(name);
    const val = Object.entries(data.value)
      .map(names => (+filter.jurisdiction_filter ? encodeChars.spaces(names.join('.')) : names[0]))
      .join(',');

    return [key, val];
  },
  decode(value, filter) {
    const {settings} = filter;
    const newValue = {};

    value.split(',').forEach((i) => {
      if (+filter.jurisdiction_filter) {
        const names = i.split('.');
        newValue[names[0]] = decodeChars.spaces(names[1] || '');
      }
      else {
        newValue[i] = decodeChars.spaces(i || '');
      }
    });

    return {
      type: settings.type,
      value: newValue,
    };
  },
};
